export const EMP_INFO_COLUMNS = {
  fnm: {
    headerId: 'EM_T_FULLNAME',
    globalColumn: 'enFnm',
  },

  jobplAddr: {
    headerId: 'EM_T_COMP_ADDR',
    globalColumn: 'enJobplAddr',
  },

  userId: {
    headerText: 'ID',
  },

  compNm: {
    headerId: 'EM_T_COMP',
    globalColumn: 'enCompNm',
  },

  deptNm: {
    headerId: 'EM_T_DEPT',
    globalColumn: 'enDeptNm',
  },

  compTelNo: {
    headerId: 'EM_T_COMP_TEL',
  },

  compFaxNo: {
    headerId: 'EM_T_COMP_FAX',
  },

  jobpoNm: {
    headerId: 'EM_T_JOB_TITLE',
    globalColumn: 'enJobpoNm',
  },

  dispJobpoNm: {
    globalColumn: 'dispEnJobpoNm',
  },

  jobgrdNm: {
    globalColumn: 'enJobgrdNm',
  },

  voipNo: {
    headerId: 'EM_T_VOIP_TEL',
  },

  empNo: {
    headerId: 'EM_T_EMP_NO',
  },

  mphonNo: {
    headerId: 'EM_T_CELL_PHONE',
  },

  nick: {
    headerId: 'EM_T_NICKNAME',
  },

  emailAddr: {
    headerId: 'EM_T_EMAIL',
  },

  chagBizCn: {
    headerId: 'EM_T_JOB',
    globalColumn: 'enChagBizCn',
  },

  dheadFnm: {
    globalColumn: 'dheadEnFnm',
  },

  dheadJobpoNm: {
    globalColumn: 'dheadEnJobpoNm',
  },
};

export const USER_PICTURE_SIZE = {
  DEF_FIRST_MAX_HEIGHT: 319,
  DEF_FIRST_MAX_WIDTH: 384,
  DEF_FIRST_MIN_HEIGHT: 240,
  DEF_FIRST_MIN_WIDTH: 260,
  DEF_RESIZE_MIN_HEIGHT: 200,
  DEF_RESIZE_MIN_WIDTH: 200,
  ZOOM_STEP_HEIGHT: 48,
  FULL_SCR_GAP_PIXEL_LIMIT: 5,
};

export const GNB_SEARCH_TAB = {
  EMP: 'EMP',
  ORG: 'ORG',
  CONTACT: 'CONTACT',
  PARTNER: 'PARTNER',
};

export const PASSWORD_RULE = {
  PASSWORD_NOREAT: 3,
  PASSWORD_NOSEQNUM: 3,
  PASSWORD_MIN: 8,
  PASSWORD_MAX: 12,
  PASSWORD_CUR_MIN: 6,
};

export const SIGNUP_RADIO = [
  {
    label: 'MB_T_EMP_MOBILE',
    value: 'mobile',
  },
  {
    label: 'MB_T_EMP_EX_EMAIL',
    value: 'epExternalMail',
  },
  {
    label: 'MB_T_EMP_CERT_KEY',
    value: 'epOpenCode',
  },
];

export const EXTERNALEMAIL = [
  '@dev.samsung.com',
  '@stage.samsung.com',
  '@samsung.com',
  '@partner.samsung.com',
  '@credu.samsung.com',
  '@and.samsung.com',
  '@csacademy.samsung.com',
  '@sams.samsung.com',
  '@inpion.samsung.com',
  '@sis.samsung.com',
  '@stm.samsung.com',
  '@sts.samsung.com',
  '@mpeon.samsung.com',
  '@emforce.samsung.com',
  '@allat.samsung.com',
  '@imc.samsung.com',
  '@imk.samsung.com',
  '@otc.samsung.com',
  '@scommtech.com',
  '@sblimotive.com',
  '@cn.samsung.com',
  '@member.samsung.com',
  '@bnts.kr',
  '@andamc.co.kr',
  '@scsacademy.com',
  '@imsws.co.kr',
  '@sissonsa.co.kr',
  '@stmnet.co.kr',
  '@u-sts.com',
  '@openhands.co.kr',
  '@s1crm.com',
  '@miracom.co.kr',
  '@samsungmedison.com',
  '@raymedical.co.kr',
  '@gesco.co.kr',
  '@credu.net',
  '@sdflex.com',
  '@secui.com',
  '@humantss.com',
  '@ppgssc.com',
  '@allat.kr',
  '@365homecare.com',
  '@samsungimc.com',
  '@opentidechina.com',
  '@sslm.co.kr',
  '@semes.com',
  '@steco.co.kr',
  '@secron.com',
  '@nexus-dx.com',
  '@nuri-solution.com',
  '@genstarre.com',
  'Japan',
  'China',
];

export const KEYCODE = {
  ESC: 'Escape',
  ENTER: 'Enter',
  NUMPADENTER: 'NumpadEnter',
  UP: 'ArrowUp',
  DOWN: 'ArrowDown',
};

export const FIND_PASSWORD = {
  STEP_1: 1,
  STEP_2: 2,
  STEP_3: 3,
  STEP_4: 4,
  STEP_2_PIN: 5,
  STEP_2_PUSH: 6,
};

export const KMS_TYPE = {
  REGISTRATION_READY: 'RD',
  REGISTRATION_COMPLETE: 'RC',
  TERMINATE_READY: 'TD',
  TERMINATE_COMPLETE: 'TC',
  UPDATE_PENDING: 'UP',
};

export const BIZ_CLASSIFIED_CODES = {
  PG: 'PG', // 행정안전부
  PP: 'PP', // 경기도 교육청
};
